import quantityId from '../enums/quantityId.js';
import Quantity from '../entities/quantity.js';
import Unit from '../entities/unit.js';

const rotation = new Quantity(
    quantityId.ROTATION,
    'Rotation'
);

rotation.registerUnit(
    new Unit(
        'rpm', 1, 'revolutions per minute', [
            'rpm'
        ]
    )
);

export default rotation;